// extracted by mini-css-extract-plugin
export default {"info":"EEJwU6mJlTa1B1CJCNsS","subHeading":"sstSDZL7x7ZHYpI3_Fzc","navLink":"ByXpMoQz9ihgjrUfNXm8"};